import { useCallback } from 'react';
import { dashboardActions } from '../../../../../../store/slices/dashboardSlice/dashboardSlice';
import { useDispatch } from 'react-redux';

export const useFinancialIndicatorsInfoElement = () => {
    const dispatch = useDispatch();
    const onClickReconciliation = useCallback(() => {
        dispatch(dashboardActions.onModalMode('reconciliation'));
    }, []);
    return { onClickReconciliation };
};
